export const forgotPasswordCode = () => {
  return {
    title: 'Actualizar Contraseña',
    subtitle: 'Por favor actualiza tu contraseña para continuar',
    subtitle_1: 'Por favor ingrese el código que fué enviado a su correo para reestablecer su contraseña.',
    code: 'Código',
    new_password: 'Ingrese una nueva Contraseña',
    reset_password: 'Reestablecer',
    invalid_password: 'Contraseña inválida',
    invalid_token: 'Token inválido',
    min_6_chars: 'La contraseña debe tener 6 caracteres o más'
  }
}
